import { CostItem, ItemGroup, CostItemComment, ItemGroupComment } from '../models/cost-item';

export const StubItemGroup: ItemGroup = {
  _id: '',
  project: '',
  department: '',
  items: [],
  costItems: [],
  total: 0,
  name: '',
  isTeam: false,
  comments: [],
  hasComment: false,
  positions: [],
};

export const StubCostItem: CostItem = {
  _id: '',
  project: '',
  itemLink: '',
  itemGroup: '',
  position: '',
  name: '',
  description: '',
  units: 0,
  cost: 0,
  days: 0,
  total: 0,
  hasComment: false,
  paymentMethod: '',
  paymentDate: new Date(),
  taxPercentage: 0,
  paidBy: '',
  accountingCategory: '',
  costStatus: '',
  dateOfBill: new Date(),
  assignedTo: '',
  hasReminder: false,
  costType: '',
  createdAt: new Date(),
  comments: [],
  orderNumber: 0,
  color: '',
  documents: []
};

export const StubCostItemComment: CostItemComment = {
  _id: '',
  text: '',
  createdAt: new Date(),
  author: '',
  item: '',
};
